import apiService from 'src/services/ApiCallService';

/**
 * Imperative backend calls for the AI Insights feature.
 *
 * Every method here is a plain async function rather than the `[result, loading, error]`
 * hook style used elsewhere in the service layer: the report poll runs from inside a
 * setInterval tick, where React hooks cannot be called. PromotionService mixes the two
 * styles for the same reason.
 */
export default class AIInsightsService {

    /**
     * Reads the status of a report the agent triggered. `userId` is "bedrock-agent" when the
     * record was created by the GenerateReport Bedrock action group.
     */
    async getReportStatus(userId: string, reportId: string): Promise<{ reportStatus?: string }> {
        return apiService.getReportStatus(userId, reportId);
    }
}
